export const blogAuthorCardComponent = {
  key: 'blogAuthorCardComponent',
  name: 'Blog author card Dept-Component',
  siteIdentifier: 'global',

  writtenByLabel: 'Written by',
};
